export default __webpack_public_path__ + "static/media/apple.2f94f4d1.svg";